var app = angular.module("leonardo");

var UserRegisterControllerAccount = function ($scope, $state, $window, AuthService, NotificationService, ngDialog,
  FilterService, FormErrorsService, SectorRestService, CountryService,
  AccountUserService, AccountService, PermissionService,
  AuthDataService, ClientInstanceService, LanguageService) {

  $scope.redirect = $state.current.redirect;
  $scope.permissionService = PermissionService;
  $scope.sectorRestService = SectorRestService;
  $scope.countryService = CountryService;
  $scope.ClientInstanceService = ClientInstanceService;
  $scope.authDataService = AuthDataService;
  $scope.languageService = LanguageService;

  $scope.statuses = [
    { id: AccountService.STATUS_PENDING, name: 'Pending' },
    { id: AccountService.STATUS_ON_BOARDING, name: 'On Boarding' }
  ];
  $scope.genders = AccountUserService.GENDER_OPTIONS;

  $scope.reset = function () {
    if ($scope.Form) {
      $scope.Form.$setPristine();
    }
    $scope.data = {
      //white_label: AuthDataService.isWhiteLabelAdmin() ? AuthDataService.getWhiteLabel() : ($scope.data && $scope.data.white_label || ''),
      client_instance: AuthDataService.isWhiteLabelAdmin() ? AuthDataService.getClientInstance() : ($scope.data && $scope.data.client_instance || ''),
      name: '',
      sector: '',
      status: '',
      country: '',
      time_zone: '',
      user: {
        first_name: '',
        last_name: '',
        password: '',
        email: '',
        // gender: '',
      },
      permissions: AuthDataService.isWhiteLabelAdmin() ?
        angular.copy(AuthDataService.authData.whiteLabel.default_account_permissions) : {}
    };
    angular.forEach(PermissionService.permissionsAccount, function (permission) {
      $scope.data.permissions[permission] = $scope.data.permissions[permission] || false;
    });
    $scope.password2 = '';
  };

  $scope.validate = function () {
    if ($scope.data.user.password !== $scope.password2) {
      NotificationService.error('Passwords don\'t match.');
      return false;
    }
    return true;
  };

  $scope.getPermissionKeys = function (group) {
    var keys = [];
    angular.forEach(PermissionService.permissionsAccount, function (key) {
      if (PermissionService.permissionAvailableAccount(key) && _.contains(key, 'permission_')
        && !_.contains(key, '_all_') && _.contains(key, group)) {
        keys.push(key);
      }
    });
    return keys;
  };

  $scope.getClassPermissionsAll = function (group) {
    if (!$scope.data) {
      return '';
    }
    if (group == 'all') {
      $scope.data.permissions.permission_all = true;
      angular.forEach(PermissionService.permissionsAccount, function (permission) {
        if (AuthDataService.authData.whiteLabel && AuthDataService.authData.whiteLabel.default_account_permissions[permission]) {
          if (!$scope.data.permissions[permission]) {
            $scope.data.permissions.permission_all = false;
          }
        }
        else if (!AuthDataService.authData.whiteLabel) {
          if ($scope.data.client_instance) {
            if ($scope.clientinstance && $scope.clientinstance.default_account_permissions[permission]) {
              if (!$scope.data.permissions[permission]) {
                $scope.data.permissions.permission_all = false;
              }
            }
          }
          else {
            if (!$scope.data.permissions[permission]) {
              $scope.data.permissions.permission_all = false;
            }
          }
        }
      });
      if ($scope.data.permissions.permission_all) {
        return 'active';
      }
      else {
        return '';
      }
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      var active = true;
      angular.forEach(keys, function (key) {
        if (!$scope.data.permissions[key]) {
          active = false;
        }
      });
      if (active) {
        $scope.data.permissions['permission_all_' + group] = true;
        return 'active';
      }
      else {
        $scope.data.permissions['permission_all_' + group] = false;
        return '';
      }
    }
  };

  $scope.selectAllPermissions = function (group) {
    if (!$scope.data) {
      return;
    }
    if (group == 'all') {
      if (!$scope.data.permissions.permission_all) {
        angular.forEach(PermissionService.permissionsAccount, function (permission) {
          if (AuthDataService.authData.whiteLabel && AuthDataService.authData.whiteLabel.default_account_permissions[permission]) {
            $scope.data.permissions[permission] = true;
          }
          else if (!AuthDataService.authData.whiteLabel) {
            if ($scope.data.client_instance) {
              if ($scope.clientinstance.default_account_permissions[permission]) {
                $scope.data.permissions[permission] = true;
              }
            }
            else {
              $scope.data.permissions[permission] = true;
            }

          }
        });
      }
      else {
        angular.forEach(PermissionService.permissionsAccount, function (permission) {
          $scope.data.permissions[permission] = false;
        });
      }
      $scope.data.permissions.permission_all = !$scope.data.permissions.permission_all;
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      if (!$scope.data.permissions['permission_all_' + group]) {
        angular.forEach(keys, function (key) {
          $scope.data.permissions[key] = true;
        });
      }
      else {
        angular.forEach(keys, function (key) {
          $scope.data.permissions[key] = false;
        });
      }
    }
  };

  $scope.ifAccountPermissions = function (group) {
    if ($scope.data.client_instance) {
      return filterWhiteLabelDefaultPermission(group);
    }
    else {
      if (AuthDataService.isAdmin()) return true;
      var keys = $scope.getPermissionKeys(group);
      var active = false;
      angular.forEach(keys, function (key) {
        if (AuthDataService.authData.whiteLabel.default_account_permissions[key]) {
          active = true;
        }
      });
      return active;
    }
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if (!$scope.validate()) {
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if($scope.data.languages){
      $scope.data.languages = (!angular.isArray($scope.data.languages)) ? $scope.data.languages.split(',').map(Number) : $scope.data.languages;
    }
    $scope.data.client_instance = $scope.data.client_instance || ($scope.defaultclientinstance && $scope.defaultclientinstance.id);  // Default LEO Client Instance;
    var register = AuthService.register($scope.data, true);
    register.then(function () {
      FilterService.init().then(function () {
        NotificationService.notify('success', 'Account Created');
        $state.go('admin.accounts');
      });
    }, function (response) {
      var data = response.data;
      if (data['user'] && data['user']['email']) {
        NotificationService.error(data['user']['email']);
        return;
      }
      if (data['user'] && data['user']['password']['password:numeric_disallowed']) {
        NotificationService.error(data['user']['password']['password:numeric_disallowed']);
        return;
      }
      if (data['user'] && data['user']['password']['password:number_not_found']) {
        NotificationService.error(data['user']['password']['password:number_not_found']);
        return;
      }
      if (data['user'] && data['user']['password']) {
        NotificationService.error(data['user']['password']);
        return;
      }
      if (data['password']) {
        NotificationService.error('Password must contain a minimum of 8 characters, at least 1 letter and 1 number.');
        return;
      }
      NotificationService.error('Unknown error, please contact site administration.');
    });
  };

  getClientInstance();
  $scope.reset();

  $scope.$watch('data.client_instance', function (newValue, oldValue) {
    if (newValue != oldValue) {
      if (newValue) {
        ClientInstanceService.get(newValue, true).then(function (data) {
          $scope.clientinstance = data;
        });
        $scope.data.permissions = AuthDataService.isWhiteLabelAdmin() ?
          angular.copy(AuthDataService.authData.whiteLabel.default_account_permissions) : {}
      }
    }
  });

  function getClientInstance() {
    ClientInstanceService.getlist({ essential: true }).then(function (data) {
      if(data && data.length > 0) {
        $scope.clientinstances = data.map( function (CI) {
          CI.name = `${CI.name} (id:${CI.id})`;
          return CI;
        });
        var defaultclientinstance = $scope.clientinstances.find(CI => CI.id == 2);
        if(defaultclientinstance){
          $scope.defaultclientinstance = defaultclientinstance.id;
          $scope.data.client_instance = $scope.data.client_instance || defaultclientinstance.id;
        }
      }
    });
  }

  function filterLogos(params) {
    return {
      ...params,
      white_label: {
        ...params.white_label,
        principal_logo: params?.white_label?.principal_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.principal_logo?.split(':data:')[1] : params?.white_label?.principal_logo,
        public_logo: params?.white_label?.public_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.public_logo?.split(':data:')[1] : params?.white_label?.public_logo,
        favicon_logo: params?.white_label?.favicon_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.favicon_logo?.split(':data:')[1] : params?.white_label?.favicon_logo,
        mobile_in_app_logo: params?.white_label?.mobile_in_app_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.mobile_in_app_logo?.split(':data:')[1] : params?.white_label?.mobile_in_app_logo,
        mobile_app_skin_logo: params?.white_label?.mobile_app_skin_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.mobile_app_skin_logo?.split(':data:')[1] : params?.white_label?.mobile_app_skin_logo
      }
    }
  };
  
  $scope.showSkinningOption = function(isWhiteLabelEnabled) {
    if(isWhiteLabelEnabled) {
      ngDialog.openConfirm({
        template: 'views/templates/admin/account/dialog/skinning-options.html',
        className: 'ngdialog-theme-default ngdialog-white-label-edit',
        controller: 'EditSkinningOptionController',
        data: $scope.clientinstance?.white_label
      }).then(function(skindata) {
        if(skindata) {
          skindata.white_label['skinning_level'] = 1; // 1: The Account has overwritten the skinning options of Client Instance
          skindata.white_label['name'] = skindata.name;
          if(skindata.white_label) {
            let filterSkinData = filterLogos(skindata);
            $scope.data.account_client_instance_white_label_mapping =  filterSkinData.white_label;
          }
        }
      });
    }
  };

  function filterWhiteLabelDefaultPermission(group) {
    var keys = $scope.getPermissionKeys(group);
    var active = false;
    angular.forEach(keys, function (key) {
      if ($scope.clientinstance && $scope.clientinstance.default_account_permissions[key]) {
        active = true;
      }
    });
    return active;
  }

  $scope.$watch('data.permission.permission_login_with_sso', function (newValue, oldValue) {
    if (!angular.equals(newValue,oldValue)){
      if (!newValue){
        $scope.data.permissions.permission_sso_get_properties_from_idp = false;
        $scope.data.permissions.permission_sso_get_role_from_idp = false;
      }
    }
  });
};

app.controller('UserRegisterControllerAccount', ['$scope', '$state', '$window', 'AuthService', 'NotificationService',
  'ngDialog', 'FilterService', 'FormErrorsService', 'SectorRestService', 'CountryService', 'AccountUserService',
  'AccountService', 'PermissionService', 'AuthDataService', 'ClientInstanceService', 'LanguageService', UserRegisterControllerAccount]);
